import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useLocationHelpers } from 'components/location/hooks/useLocationHelpers';
import { MenuSchedulingTable } from 'components/menu-manager/menu-scheduling/MenuSchedulingTable';
import { menuOptionsApi } from 'components/menu-manager/MenuOptionsApi';
import { EnrichedMenuOption } from 'components/menu-manager/MenuOptionsModel';
import { LOCATIONS, LOCATION_VIEW } from 'config/routes';
import { MainLayout } from 'layouts/MainLayout';
import React from 'react';
import { useParams } from 'react-router-dom';
import { getAllPerks } from 'store/perks/perksSlice';
export const MenuScheduling = () => {
    const dispatch = useAppDispatch();

    const { locationId } = useParams<{ locationId: string }>();
    const { locationIdToLocationName } = useLocationHelpers();
    const { perks } = useAppSelector(state => state.perks);

    const [menuOptions, setMenuOptions] = React.useState<EnrichedMenuOption[]>([]);
    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {
        if (locationId) {
            setIsLoading(true);
            menuOptionsApi
                .getMenuOptionsByLocation(locationId)
                .then(res => {
                    if (res.ok && res.body) {
                        setMenuOptions(res.body);
                    }
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    }, [locationId]);

    React.useEffect(() => {
        dispatch(getAllPerks());
    }, [dispatch]);

    return (
        <MainLayout
            pageName="Menu Scheduling"
            pageDescription="Schedule your menus for a specific location"
            breadcrumbs={[
                {
                    label: 'Locations',
                    url: LOCATIONS
                },
                {
                    label: locationIdToLocationName.get(locationId),
                    url: LOCATION_VIEW.replace(':locationId', locationId)
                }
            ]}
            noScroll
        >
            <MenuSchedulingTable isLoading={isLoading} list={menuOptions} perks={perks} />
        </MainLayout>
    );
};
